import { Center, Text3D } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import GosNIIASDescription from "./GosNIIASDescription.jsx";

const SIZE = 2;

export default function GosNIIASText({ position = [0, 0, 0] }) {
  return (
    <Center position={position}>
      <GosNIIASDescription />
      <RigidBody
        type="dynamic"
        mass={0.001}
        restitution={1}
        friction={0.05}
        linearDamping={0.01}
        angularDamping={0.01}
        colliders="cuboid"
      >
        <group>
          <Center position={[0, 0, -7]}>
            <Text3D
              font="/fonts/helvetiker_regular.typeface.json"
              size={SIZE}
              height={0.5}
              curveSegments={12}
              bevelEnabled
              bevelThickness={0.05}
              bevelSize={0.05}
            >
              GosNIIAS
              <meshStandardMaterial color="#ffffff" />
            </Text3D>
          </Center>
        </group>
      </RigidBody>
    </Center>
  );
}
